/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-22 18:20:32
 * @LastEditors: limin
 * @LastEditTime: 2021-03-29 11:52:45
 */
import publicApis from './public'
import GoodsApis from './modules/goods'
import UserApis from './modules/user'
import AddressApis from './modules/address'
import CartApis from './modules/cart'
import OrderApis from './modules/order'

export default {
  public: publicApis,
  goods: GoodsApis,
  user:UserApis,
  address:AddressApis,
  cart:CartApis,
  order:OrderApis,
}
